import React from "react";
import { Ico } from "./produits/productsShared";
import "./mobile-module-header.css";

/**
 * @param {{
 *   label: string,
 *   onClick?: () => void,
 *   icon?: string,
 *   children?: React.ReactNode,
 *   badge?: string | number,
 *   active?: boolean,
 *   disabled?: boolean,
 * }} props
 */
export function MobileHeaderAction(props) {
  const {
    label,
    onClick,
    icon,
    children,
    badge,
    active = false,
    disabled = false,
  } = props;
  return (
    <button
      type="button"
      className={`ea-module-header__action${active ? " is-active" : ""}`}
      aria-label={label}
      aria-pressed={active || undefined}
      onClick={onClick}
      disabled={disabled}
    >
      {children || (icon ? <Ico name={icon} /> : null)}
      {badge != null && Number(badge) > 0 ? (
        <span className="ea-module-header__badge">{badge}</span>
      ) : null}
    </button>
  );
}

/**
 * @param {{
 *   title: React.ReactNode,
 *   subtitle?: React.ReactNode,
 *   onMenu?: () => void,
 *   onLeading?: () => void,
 *   leadingIcon?: string,
 *   leadingLabel?: string,
 *   actions?: React.ReactNode,
 *   context?: React.ReactNode,
 *   children?: React.ReactNode,
 *   className?: string,
 * }} props
 */
export default function MobileModuleHeader(props) {
  const {
    title,
    subtitle,
    onMenu,
    onLeading,
    leadingIcon,
    leadingLabel,
    actions,
    context,
    children,
    className = "",
  } = props;
  const leadingHandler = onMenu || onLeading;
  const resolvedLeadingIcon = onMenu ? "menu" : leadingIcon;
  const resolvedLeadingLabel = onMenu ? "Ouvrir le menu" : leadingLabel;

  return (
    <header className={`ea-module-header ${className}`.trim()}>
      <div className="ea-module-header__row">
        {leadingHandler ? (
          <button
            type="button"
            className="ea-module-header__action"
            aria-label={resolvedLeadingLabel || "Navigation"}
            onClick={leadingHandler}
          >
            <Ico name={resolvedLeadingIcon || "arrow-left"} />
          </button>
        ) : null}

        <div className="ea-module-header__copy">
          <h1>{title}</h1>
          {subtitle ? <span>{subtitle}</span> : null}
        </div>

        {actions ? <div className="ea-module-header__actions">{actions}</div> : null}
      </div>

      {context ? <div className="ea-module-header__context">{context}</div> : null}
      {children ? <div className="ea-module-header__extras">{children}</div> : null}
    </header>
  );
}
